import { render, staticRenderFns } from "./PageDicts.vue?vue&type=template&id=5c743a60&scoped=true&"
import script from "./PageDicts.vue?vue&type=script&lang=js&"
export * from "./PageDicts.vue?vue&type=script&lang=js&"
import style0 from "./PageDicts.vue?vue&type=style&index=0&id=5c743a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c743a60",
  null
  
)

export default component.exports